import { m } from "@/paraglide/messages";

export interface SylExplainerProps {
  howTo: string;
  faqs: Array<{ q: string; a: string }>;
}

/** How-to + FAQ block. The matching FAQPage JSON-LD is emitted by the route. */
export function SylExplainer({ howTo, faqs }: SylExplainerProps) {
  return (
    <div className="mt-12 space-y-10">
      <section className="pct-card space-y-4 rounded-2xl p-6 sm:p-7">
        <h2 className="font-display text-xl font-bold tracking-tight">
          {m.syl_howto_title()}
        </h2>
        <p className="max-w-2xl whitespace-pre-line leading-relaxed text-muted-foreground">
          {howTo}
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="px-1 font-display text-xl font-bold tracking-tight">
          {m.syl_faq_title()}
        </h2>
        <dl className="space-y-3">
          {faqs.map((f) => (
            <div key={f.q} className="pct-panel rounded-xl p-5">
              <dt className="flex items-start gap-3 font-semibold text-foreground">
                <span
                  aria-hidden
                  className="pct-chip grid h-6 w-6 shrink-0 place-items-center rounded-md font-display text-xs font-bold"
                >
                  Q
                </span>
                <span className="pt-0.5">{f.q}</span>
              </dt>
              <dd className="mt-2 pl-9 text-sm leading-relaxed text-muted-foreground">
                {f.a}
              </dd>
            </div>
          ))}
        </dl>
      </section>
    </div>
  );
}
